module.exports = "/booking/_next/static/images/logo-allegiant-white-e48c63f3074f641bdd02e3dbe63f0d1d.svg";